/*
 * @Author: zhoubiao
 * @Date: 2021-03-23 13:35:42
 * @LastEditors: zhoubiao
 * @LastEditTime: 2021-04-12 09:57:14
 * @FilePath: \ICCSIP2020\src\i18n\langs\index.js
 */
import cn from './cn'
import en from './en'

export default {
  en,
  cn
}
